import { useTranslation } from "react-i18next";
import TrendzContainerCard from "../../../components/TrendzContainerCard";

export default function BrandingManagementPage() {
  const { t } = useTranslation(["common", "social", "sidebar"]);
  return (
    <TrendzContainerCard
      title={t("social:branding_management")}
    ></TrendzContainerCard>
  );
}
